import 'show-page/styles/index.less';
import 'common/analytics/auth-tracker';
import 'core-js/fn/date/now';
import 'core-js/fn/object/assign';
import 'core-js/fn/array/from';
import 'core-js/fn/string/trim';
import 'core-js/fn/promise';
import 'gsap/easing/EasePack';
import 'gsap/plugins/CSSPlugin';
import 'gsap/plugins/ScrollToPlugin';
import 'TweenLite';
import AdManager from 'show-page/stores/ad-manager';
import CVPAuthStore from 'common/stores/cvp-auth';
import ShowPage from 'show-page/containers/main';
import ShowStore from 'show-page/stores/show';
import UIStore from 'show-page/stores/ui';
import { browserHistory, Route, Router } from 'react-router';
import { cloneDeep } from 'lodash';
import { Provider } from 'mobx-react';
import { render } from 'react-dom';
import { SHOWS_BASE_URL } from 'show-page/constants/config';


const INITIAL_DATA = cloneDeep(window.__AS_INITIAL_DATA__);
const showStore = new ShowStore(INITIAL_DATA.show);
const uiStore = new UIStore(INITIAL_DATA.ui);
const adManager = new AdManager(showStore, uiStore);


if (process.env.NODE_ENV === 'development') {
    // require('common/utils/dev-tools');
    window.CVPAuthStore = CVPAuthStore;
    window.ShowAdManager = adManager;
    window.ShowStore = showStore;
    window.UIStore = uiStore;
    window.toJS = require('mobx').toJS;
}


TweenLite.defaultEase = Expo.easeInOut;

render(
    <Provider
        adManager={ adManager }
        cvpAuthStore={ CVPAuthStore }
        showStore={ showStore }
        uiStore={ uiStore }>
        <Router history={ browserHistory }>
            <Route
                component={ ShowPage }
                onEnter={ showStore.handleRouteEnter }
                onChange={ showStore.handleRouteChange }
                path={`${SHOWS_BASE_URL}/:show`}>
                <Route path=':video' />
            </Route>
        </Router>
    </Provider>,
    document.getElementById('show-page')
);



// WEBPACK FOOTER //
// ./src/show-page/index.js